import axios from "axios";
import authHeader from "./auth-header";
import AuthService from "./auth.service";
import { config } from "../config";

class TransportDocumentService {
  getTransportDocuments(params = {}) {
    return axios
      .post(`${config["apiUrl"]}transport-documents`,
        { headers: authHeader(), params: params },
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getTransportDocumentsLocations(params = {}) {
    return axios
      .get(`${config["apiUrl"]}transport-documents/locations`, {
        headers: authHeader(),
        params: params
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

    createTransportDocument(data) {
        return axios.post(`${config["apiUrl"]}transport-documents/store`, data, {
                headers: authHeader(),
            })
            .then((response) => {
                return response;
            })
            .catch((error) => {
                if (error.response.status == 401) {
                    AuthService.logout();
                    window.location = "/login";
                }
                console.log("ERROR:: ", error.response.data);
                return error.response;
            });
    }

    updateTransportDocument(stamp, data) {
        let id = encodeURIComponent(stamp);

        return axios
            .put(`${config["apiUrl"]}transport-documents/update/${id}`, data, {
                headers: authHeader(),
            })
            .then((response) => {
                return response;
            })
            .catch((error) => {
                if (error.response.status == 401) {
                    AuthService.logout();
                    window.location = "/login";
                }
                console.log("ERROR:: ", error.response.data);
                return error.response;
            });
    }

    updateOrCreateTransportDocument(data) {
        return axios
            .post(`${config["apiUrl"]}transport-documents/update-or-create`, data, {
                headers: authHeader(),
            })
            .then((response) => {
                return response;
            })
            .catch((error) => {
                if (error.response.status == 401) {
                    AuthService.logout();
                    window.location = "/login";
                }
                console.log("ERROR:: ", error.response.data);
                return error.response;
            });
    }

    query(params) {
      return axios
        .get(`${config["apiUrl"]}transport-documents/query`, {
          headers: authHeader(),
          params: params,
        })
        .then((response) => {
          if (response.status == 200) {
            return response.data;
          }
          return null;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            AuthService.logout();
            window.location = "/login";
          }
          console.log("ERROR:: ", error.response.data);
          return null;
    });
  }
}
export default new TransportDocumentService();
